import { useState } from 'react';
import { Button, Tooltip } from '@arco-design/web-react';
import { IconHandUp } from '../../components';
import { useViewRole } from '../../hooks/useViewRole';
import SupportRequestDrawer from '../../pages/support/SupportRequestDrawer';
import type { SupportLevel } from '../../pages/support/mock';

/**
 * 顶栏「请求支援」入口（举手）：**常显**，不再只在通话/会话中才出现。
 *
 * 层级按当前视图角色决定：坐席 → 组长；组长 → 值班长；值班长/管理员 → 上报。
 * 演示版：点开是填单抽屉，提交只写本地 mock，不发请求、不打扰真人。
 */
export default function SupportRequestButton() {
  const viewRole = useViewRole();
  const [visible, setVisible] = useState(false);

  const level: SupportLevel = viewRole === 'agent' ? 'agent' : viewRole === 'leader' ? 'leader' : 'duty';
  const label =
    level === 'agent'
      ? '举手求助（可发给组长、班长或技术，带当前通话/会话）'
      : level === 'leader'
        ? '向值班长求助（带本组快照）'
        : '上报管理员 / 技术值班';

  return (
    <>
      <Tooltip content={label}>
        <Button
          type="text"
          shape="circle"
          className="bcc-support-request"
          icon={<IconHandUp />}
          aria-label={label}
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <SupportRequestDrawer visible={visible} onClose={() => setVisible(false)} level={level} />
    </>
  );
}
